var INVALIDMAXFILESIZE = 'invalidMaxFileSize';
var INVALIDMINFILESIZE = 'invalidMinFileSize';
var INVALIDFILEEXTENSION = 'invalidFileExtension';
var validateFileExtension = function (file, allowedExtensions) {
    if (allowedExtensions.length > 0) {
        if (allowedExtensions.indexOf((file.extension || '').toLowerCase()) < 0) {
            file.validationErrors = file.validationErrors || [];
            if (file.validationErrors.indexOf(INVALIDFILEEXTENSION) < 0) {
                file.validationErrors.push(INVALIDFILEEXTENSION);
            }
        }
    }
};
var validateFileSize = function (file, minFileSize, maxFileSize) {
    if (minFileSize !== 0 && (file.size || 0) < minFileSize) {
        file.validationErrors = file.validationErrors || [];
        if (file.validationErrors.indexOf(INVALIDMINFILESIZE) < 0) {
            file.validationErrors.push(INVALIDMINFILESIZE);
        }
    }
    if (maxFileSize !== 0 && (file.size || 0) > maxFileSize) {
        file.validationErrors = file.validationErrors || [];
        if (file.validationErrors.indexOf(INVALIDMAXFILESIZE) < 0) {
            file.validationErrors.push(INVALIDMAXFILESIZE);
        }
    }
};
var parseAllowedExtensions = function (extensions) {
    var allowedExtensions = extensions.map(function (ext) {
        var parsedExt = (ext.substring(0, 1) === '.') ? ext : ('.' + ext);
        return parsedExt.toLowerCase();
    });
    return allowedExtensions;
};
var validateFiles = function (files, restrictionInfo) {
    var allowedExtensions = parseAllowedExtensions(restrictionInfo.allowedExtensions || []);
    var maxFileSize = restrictionInfo.maxFileSize || 0;
    var minFileSize = restrictionInfo.minFileSize || 0;
    var i;
    for (i = 0; i < files.length; i++) {
        validateFileExtension(files[i], allowedExtensions);
        validateFileSize(files[i], minFileSize, maxFileSize);
    }
};
export default {
    validateFiles: validateFiles
};
//# sourceMappingURL=validationUtils.js.map